//BFSG

import * as React from 'react'
import styled from 'styled-components'
import ArrowDown from 'assets/arrow-down.svg'
import ArrowUp from 'assets/arrow-up.svg'
import theme from 'theme'
import useInView from 'hooks/useInView'

type Props = {
  label?: string
  children: any
  disableToggle?: any
  eventVisible?: any
  eventClick?: any
}

export default function Accordion(props: Props) {
  const [open, setOpen] = React.useState(props.disableToggle)
  const [ref, refInVp] = useInView<HTMLDivElement>(50, true)
  React.useEffect(() => {
    if (refInVp) {
      props.eventVisible && props.eventVisible()
    }
  }, [refInVp])
  const handleClick = () => {
    setOpen(!open)
    if (!open) {
      props.eventClick && props.eventClick()
    }
  }
  if (props.disableToggle) {
    return (
      <Wrapper className="Accordion" data-cy-ctx="molecules/Accordion">
        <div
          className={'label' + (!props.label ? ' disabledToggle' : '')}
          data-cy-state="toggle-disabled"
        >
          {props.label && <h3 data-cy-state="has-label">{props.label}</h3>}
        </div>
        <div className="content">{props.children}</div>
      </Wrapper>
    )
  }

  return (
    <Wrapper className="Accordion" data-cy-ctx="molecules/Accordion" ref={ref}>
      <button
        className="label"
        onClick={handleClick}
        data-cy-handle="toggle-content"
        aria-label={open ? 'collapse' : 'expand'} // TODO: bfsg accordion-expanded and accordion-collapsed
        aria-expanded={open ? 'true' : 'false'}
      >
        {props.label && <h3 data-cy-state="has-label">{props.label}</h3>}
        {open ? (
          <ArrowUp data-cy-state="show-arrow-up" />
        ) : (
          <ArrowDown data-cy-state="show-arrow-down" />
        )}
      </button>
      {props.children && open && (
        <div className="content" data-cy-state="show-content">
          {props.children}
        </div>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  > .label {
    padding: ${theme.spacing('ml')} 0;

    > h3 {
      ${theme.ty('rc-base')}

      @media (min-width: ${theme.ms.SM}px) {
        ${theme.ty('rc-2xl')}
      }
      color: ${theme.colors.b0};
    }
  }

  > .disabledToggle {
    padding-bottom: 0;
  }

  > button {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;

    > svg {
      margin-right: ${theme.spacing('m')};
    }
  }

  > .content {
    margin-bottom: ${theme.spacing('ml')};
  }
`
